import { config } from "_config";
import { authHeader, getApiProxyUrl, handleResponse } from "_helpers";

const { ordersApiUrl } = config;

export const constantService = {
  getProcessingStatuses,
  crmGetProcessingStatuses,
  getProcessingErrors,
  crmGetProcessingErrors,
  getProductFileTypes,
};

function getProcessingStatuses() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${ordersApiUrl}/category/TRADEMARKS/processing-statuses`;

  return fetch(url, requestOptions).then(handleResponse);
}

function crmGetProcessingStatuses() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${getApiProxyUrl()}/category/TRADEMARKS/processing-statuses`;

  return fetch(url, requestOptions).then(handleResponse);
}

function getProcessingErrors() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${ordersApiUrl}/category/TRADEMARKS/processing-errors`;

  return fetch(url, requestOptions).then(handleResponse);
}

function crmGetProcessingErrors() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${getApiProxyUrl()}/category/TRADEMARKS/processing-errors`;

  return fetch(url, requestOptions).then(handleResponse);
}

function getProductFileTypes(code) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${ordersApiUrl}/category/products/${code}/file-types`;

  return fetch(url, requestOptions).then(handleResponse);
}
